var map = {
	"./WelcomeEmail.png": "792c",
	"./facebook-logo.png": "51c4",
	"./generic-player.png": "201e",
	"./powered-by-wifeed.png": "273b",
	"./undefined-video.png": "b7c9",
	"./vimeo.png": "1ded",
	"./youtube.png": "3d43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";